import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { api } from "../api";

const fmt = (iso) => new Date(iso).toLocaleString("tr-TR", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

const SohbetlerTab = () => {
  const [logs, setLogs] = useState(null);
  const [contacts, setContacts] = useState(null);
  const [openIdx, setOpenIdx] = useState(null);

  useEffect(() => {
    api.get("/admin/chat-logs").then(({ data }) => setLogs(data.logs)).catch(() => setLogs([]));
    api.get("/admin/contacts").then(({ data }) => setContacts(data.messages)).catch(() => setContacts([]));
  }, []);

  if (!logs || !contacts) return <p className="text-sm text-ink-500">Yükleniyor...</p>;

  return (
    <div data-testid="sohbetler-tab">
      <h1 className="text-2xl font-bold tracking-tight text-ink-900 sm:text-3xl">AI Sohbetleri</h1>
      <p className="mt-2 text-sm text-ink-500">Ziyaretçilerin Yalı Asistan ile konuşmaları.</p>

      <div className="mt-8 space-y-px border border-line bg-line">
        {logs.length === 0 && <div className="bg-white p-10 text-center text-sm text-ink-400">Henüz sohbet kaydı yok.</div>}
        {logs.map((log, i) => {
          const firstUser = log.messages.filter((m) => m.role === "user").pop();
          const open = openIdx === i;
          return (
            <div key={i} className="bg-white" data-testid={`chatlog-${i}`}>
              <button
                onClick={() => setOpenIdx(open ? null : i)}
                className="flex w-full items-center justify-between gap-4 p-5 text-left"
                data-testid={`chatlog-toggle-${i}`}
              >
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-ink-900">
                    {firstUser ? firstUser.content : "—"}
                  </p>
                  <p className="mt-1 text-xs text-ink-400">{fmt(log.created_at)} · {log.messages.length} mesaj</p>
                </div>
                {open ? <ChevronUp size={16} className="shrink-0 text-ink-400" /> : <ChevronDown size={16} className="shrink-0 text-ink-400" />}
              </button>
              {open && (
                <div className="space-y-2 border-t border-line bg-cream-100 p-5">
                  {log.messages.filter((m) => m.role !== "system").map((m, j) => (
                    <div key={j} className={`max-w-[85%] px-3.5 py-2.5 text-xs leading-relaxed ${
                      m.role === "user" ? "ml-auto bg-ink-900 text-cream-50" : "border border-line bg-white text-ink-800"
                    }`}>
                      {m.content.replace("[WHATSAPP]", "").trim()}
                    </div>
                  ))}
                  <div className="max-w-[85%] border border-line bg-cream-200 px-3.5 py-2.5 text-xs leading-relaxed text-ink-800">
                    <span className="font-bold">Asistan: </span>{log.reply.replace("[WHATSAPP]", "").trim()}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <h2 className="mt-12 text-xl font-bold tracking-tight text-ink-900">İletişim Formu Mesajları</h2>
      <div className="mt-4 space-y-px border border-line bg-line">
        {contacts.length === 0 && <div className="bg-white p-10 text-center text-sm text-ink-400">Henüz mesaj yok.</div>}
        {contacts.map((c, i) => (
          <div key={i} className="bg-white p-5" data-testid={`contact-msg-${i}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <p className="text-sm font-bold text-ink-900">{c.name} <span className="font-normal text-ink-400">· {c.phone}</span></p>
              <p className="text-xs text-ink-400">{fmt(c.created_at)}</p>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-ink-500">{c.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SohbetlerTab;
